/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Images/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AllImages from './AllImages/index'
import Itero from './Itero/index'
import Misc from './Misc/index'
import No from './No/index'
import React from 'react'
import Standard from './Standard/index'
import Videos from './Videos/index'



/** @type {import('Simple/types.js').View} */
export default function Images({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabSelectedImagesLayoutValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.images.layout',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabSelectedImagesLayoutValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AllImages'}>
<AllImages
  viewPath={`${viewPath}/AllImages`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Misc'}>
<Misc
  viewPath={`${viewPath}/Misc`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Standard'}>
<Standard
  viewPath={`${viewPath}/Standard`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Videos'}>
<Videos
  viewPath={`${viewPath}/Videos`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Itero'}>
<Itero
  viewPath={`${viewPath}/Itero`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}